export default __webpack_public_path__ + "static/media/me.74391848.png";